export default __webpack_public_path__ + "static/media/November2019.60b3dfe3.png";